import React, { Suspense, lazy } from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';

/**
 * Pequeñas Puntadas sales page.
 * HERO → PRENDAS → BENEFICIOS → MODELO POR DENTRO → BONOS → OFERTA →
 * VOLÚMENES → PÁGINAS INTERIORES → PREGUNTAS → CIERRE → FOOTER (+ barra móvil tras la oferta).
 * Everything below the hero loads in separate chunks; each block reserves height.
 */
const named = <K extends string,>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) => lazy(() => loader().then(m => ({
  default: m[key]
})));
const GallerySection = named(() => import('./components/sections/GallerySection'), 'GallerySection');
const ModelPreviewSection = named(() => import('./components/sections/ModelPreviewSection'), 'ModelPreviewSection');
const BenefitsSection = named(() => import('./components/sections/BenefitsSection'), 'BenefitsSection');
const InteriorPagesSection = named(() => import('./components/sections/InteriorPagesSection'), 'InteriorPagesSection');
const CollectionSection = named(() => import('./components/sections/CollectionSection'), 'CollectionSection');
const BonusSection = named(() => import('./components/sections/BonusSection'), 'BonusSection');
const OfferSection = named(() => import('./components/sections/OfferSection'), 'OfferSection');
const FaqSection = named(() => import('./components/sections/FaqSection'), 'FaqSection');
const FinalCta = named(() => import('./components/sections/FinalCta'), 'FinalCta');
const Footer = named(() => import('./components/Footer'), 'Footer');
const StickyBuyBar = named(() => import('./components/StickyBuyBar'), 'StickyBuyBar');
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
  id?: string;
}

/** The fallback carries the section id so anchors resolve before the chunk loads. */
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory',
  id
}: DeferredProps) {
  return <Suspense fallback={<div id={id} className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="sssq8ntq6c9v" />} data-id="element-0" data-mp="stc9c7v436ph">
      {children}
    </Suspense>;
}
export function App() {
  return <div className="app-root bg-ivory text-graphite" data-id="element-2" data-mp="3udkmtw2p4uae">
      <NavBar data-id="element-3" data-mp="3uf5hrmsxaf8s" />
      <main data-id="element-4" data-mp="d4e5zu7z1ex8">
        <Hero data-id="element-5" data-mp="d57ep0qhqei0" />
        <Deferred minHeight="1800px" background="bg-blush" id="prendas" data-id="element-6" data-mp="d3mkxdc02zl7">
          <GallerySection data-id="element-7" data-mp="85ukfuxai55e" />
        </Deferred>
        <Deferred minHeight="620px" data-id="element-8" data-mp="8648hcyry28g">
          <BenefitsSection data-id="element-9" data-mp="3gle88ef6yvd2" />
        </Deferred>
        <Deferred minHeight="1100px" background="bg-ivory-deep" id="modelo" data-id="element-10" data-mp="3gm64zskiyz4x">
          <ModelPreviewSection data-id="element-11" data-mp="3bn2y02kziiub" />
        </Deferred>
        <Deferred minHeight="800px" background="bg-blush" id="bonos" data-id="element-12" data-mp="3bk70gfd1tw6e">
          <BonusSection data-id="element-13" data-mp="3qbze8mx73260" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-ivory-deep" id="oferta" data-id="element-14" data-mp="3qd0owqaatmn7">
          <OfferSection data-id="element-15" data-mp="3lj6bg4lae3wk" />
        </Deferred>
        <Deferred minHeight="1000px" id="volumenes" data-id="element-16" data-mp="2xudaftpt55v3">
          <CollectionSection data-id="element-17" data-mp="2xt2ak4zhgi99" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-paper" id="paginas" data-id="element-18" data-mp="2swbu3gjrnknb">
          <InteriorPagesSection data-id="element-19" data-mp="18drjdvxkvfdt" />
        </Deferred>
        <Deferred minHeight="700px" id="preguntas" data-id="element-20" data-mp="18cznsl3zdhnj">
          <FaqSection data-id="element-21" data-mp="1d4hqpepkdsb5" />
        </Deferred>
        <Deferred minHeight="420px" background="bg-coral-deep" data-id="element-22" data-mp="1d59kql3ijhzb">
          <FinalCta data-id="element-23" data-mp="yfva79o7auic" />
        </Deferred>
      </main>
      <Deferred minHeight="240px" background="bg-graphite-deep" data-id="element-24" data-mp="yheqv1drr7kn">
        <Footer data-id="element-25" data-mp="13dwutz19z1vx" />
      </Deferred>

      <Suspense fallback={null} data-id="element-26" data-mp="13ey541agvkcl">
        <StickyBuyBar data-id="element-27" data-mp="1r495virtheqq" />
      </Suspense>
    </div>;
}